/* eslint-disable new-cap */
import { gql } from "@apollo/client";
import { Instance as instance } from "../fragments";

const FETCH_INSTANCE = props => gql`
  query FetchInstance($id: Int) {
    instance(id: $id) {
      ${instance(props)}
    }
  }
`;

const FETCH_INSTANCES = props => gql`
  query FetchInstances($input: InstanceFilterInput!) {
    instances(input: $input) {
      count
      edges {
        ${instance(props)}
      }
      error
    }
  }
`;

const FETCH_INSTANCE_DESCRIPTIONS = props => gql`
  query FetchInstanceDescriptions($input: AdvInstanceFilterInput!) {
    instancesV2(input: $input) {
      count
      edges {
        id
        description
      }
    }
  }
`;

const FETCH_INSTANCES_V2 = props => gql`
  query FetchInstancesV2($input: AdvInstanceFilterInput!) {
    instancesV2(input: $input) {
      count
      edges {
        ${instance(props)}
      }
      sqlQuery
    }
  }
`;

const FETCH_INSTANCES_LIST = gql`
  query FetchInstancesV2($input: AdvInstanceFilterInput!) {
    instancesV2(input: $input) {
      count
      edges {
        id
        edition {
          artwork {
            artists {
              name
              contact {
                surname
              }
            }
            imagesSummary {
              imgT
              imgX
            }
            title
          }
          number
          year
        }
        editionNumber
        name
        status {
          name
        }
        value {
          value
          currency {
            code
          }
        }
      }
      sqlQuery
    }
  }
`;

const FETCH_INSTANCE_GALLERY = gql`
  query FetchInstanceGallery($id: Int) {
    instance(id: $id) {
      id
      name
      description
      editionNumber
      edition {
        id
        number
        year
        artwork {
          id
          title
          description
          medium
          dimensions
          precis
          artists {
            id
            name
            contact {
              surname
            }
          }
          images {
            archiveId
            order
            imgT
            imgX
          }
        }
      }
      status {
        name
      }
      value {
        value
        date
        currency {
          code
        }
      }
      consignmentValue {
        value
        date
        currency {
          code
        }
      }
    }
  }
`;

export {
  FETCH_INSTANCE,
  FETCH_INSTANCE_GALLERY,
  FETCH_INSTANCES,
  FETCH_INSTANCES_V2,
  FETCH_INSTANCES_LIST,
  FETCH_INSTANCE_DESCRIPTIONS,
};
